











import {Vue, Component, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import axios from 'axios';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';
import {getBaseURL} from '@/common';
@Component({
    components: {
        GenericDialog,
    },
})
export default class PasswordChangeDialog extends Mixins(GlobalAlertMixin) {
    public loading = false;
    public open = false;
    public validForm = false;
    public password = '';
    public passwordOld = '';
    @Watch('open')
    public onOpenChanged(value: boolean, oldValue: boolean) {
        if (!value) {
            this.password = '';
            this.passwordOld = '';
        }
    }
    public passwordRules = [
        (v) => !!v || 'Password is required',
        (v) => v.length >= 5 || 'Password must be at least 5 characters',
    ];
    public async tryChange() {
        // const url =``;
        const url = `${getBaseURL()}/authManagement/`;
        axios.defaults.headers.common.Authorization = `Bearer ${this.$store.state.auth.accessToken}`;
        const headers = {Authorization: `Bearer ${this.$store.state.auth.accessToken}`, Accept: 'application/json'};
        try {
            const config = {
                method: 'POST',
                headers,
                action: 'passwordChange',
                value: {
                    user: {email: this.$store.state.auth.user.email},
                    oldPassword: this.passwordOld,
                    password: this.password,
                },
            };
            const response = await axios.post(url, config);
            if (response.status === 201) {
                this.showAlert('Successfully Changed!', 'success');
                this.open = false;
            } else {
                this.showAlert(`Server encountered a ${response.status} error`);
            }
        } catch (e) {
            this.showAlert(`Server encountered an error`);
        }
    }

}
